<mat-card class="welcome-card">
  <mat-card-header class="d-flex justify-content-center">
    <img
      src="assets/icons/avyna/logo.svg"
      [alt]="'backoffice.shell.logo_alt' | translate"
      class="avyna-logo pb-3"
    />
  </mat-card-header>

  <mat-card-content class="text-center">
    <div class="mb-4">
      <h1 class="fs-2 fw-bold title-text mb-3">{{ 'backoffice.auth.login.title' | translate }}</h1>
      <p class="fs-6 subtitle-text mb-0">{{ 'backoffice.auth.login.subtitle' | translate }}</p>
    </div>

    <button
      mat-flat-button
      type="button"
      class="w-100 microsoft-btn"
      [disabled]="isRedirecting()"
      (click)="signInWithMicrosoft()"
    >
      @if (isRedirecting()) {
        <mat-spinner diameter="20" class="d-inline-block me-2"></mat-spinner>
        <span>{{ 'backoffice.auth.login.connecting' | translate }}</span>
      } @else {
        <img
          src="assets/icons/microsoft_icon.svg"
          alt=""
          class="d-inline-block me-2 microsoft-icon"
        />
        <span>{{ 'backoffice.auth.login.microsoft' | translate }}</span>
      }
    </button>

    <div class="d-flex align-items-center justify-content-center security-hint small gap-2 pt-3">
      <mat-icon>security</mat-icon>
      <span>{{ 'backoffice.auth.login.sso_hint' | translate }}</span>
    </div>
  </mat-card-content>
</mat-card>
